import { Button, Card, Header, Image, Label } from "semantic-ui-react"
import React, { useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { searchVehicleByVin, selectVehicle } from "../../../v1/actions/vehicles"
import store from "../../../shared_component/utils/configureStore"
import placeholderCarImg from "../../../images/placeholder_car.svg"
import { routerPaths } from "../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import { getPopularServices } from "../../../v1/actions/services"
import { updateCart } from "../../../v1/actions/user"
import Notifications from "../../../v1/components/Notifications"
import {
  gaJSON,
  serviceSelectedEvents,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"

const VehicleInfo = ({ t, history, location, user, vehicle, handleSearchAgain, cart }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const queryParams = new URLSearchParams(location.search)
  const isOilChangeService = queryParams.get("oil_change") || ""

  const handleToggleVehicleInfo = async () => {
    await store.dispatch(selectVehicle({}))
    handleSearchAgain()
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_not_my_vehicle_click
    })
  }

  const handleVehicleSubmit = async () => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_it_is_my_vehicle_click
    })
    setIsSubmitting(true)
    if (vehicle.id === user.activeVehicleId) {
      history.push({
        pathname: routerPaths.shopSelection
      })
    } else {
      const success = await store.dispatch(searchVehicleByVin(vehicle.vin, true))
      if (typeof success === "boolean") {
        setIsSubmitting(false)
        if (isOilChangeService === "true") {
          const res = await fetchPopularServices()
          if (res) {
            history.push({
              pathname: routerPaths.shopSelection
            })
          }
        } else {
          history.push({
            pathname: routerPaths.addServices
          })
        }
      } else {
        trackFirebaseAnalytics({
          event: gaJSON.EtoB_vehicle_submit_error
        })
        store.dispatch(
          Notifications.error({
            title: t("errorLbl"),
            message: success.toString(),
            position: "tr",
            autoDismiss: 5,
            action: {
              label: "Dismiss"
            }
          })
        )
        setIsSubmitting(false)
      }
    }
  }

  const fetchPopularServices = async () => {
    setIsSubmitting(true)
    const services = await store.dispatch(getPopularServices({ vehicle_id: vehicle.id || null }))
    if (services !== null && services.length) {
      setIsSubmitting(false)
      const service = services.find((service) => service.reference_id === "oil_change")
      return await addService(service, "added")
    } else {
      setIsSubmitting(false)
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: "Something went wrong",
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      return false
    }
  }

  const addService = async (service, event) => {
    setIsSubmitting(true)
    let opts = {
      successCallback: async () => {
        await serviceSelectedEvents({
          serviceDefinition: service,
          position: service.position,
          vehicle
        })
      }
    }
    try {
      await store.dispatch(
        updateCart(
          [
            {
              service_definition_id:
                service.service_id || service.id || service.service_definition_id,
              event: event,
              prepaid: service.prepaid,
              position: vehicle.oil_type_name || ""
            }
          ],
          cart.vehicle_id,
          null,
          undefined,
          opts
        )
      )
      setIsSubmitting(false)
      return true
    } catch (error) {
      setIsSubmitting(false)
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: error.toString(),
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      return false
    }
  }

  return (
    <Card className="vehicle-info-card" raised={true}>
      <div className="vehicle-info">
        <Header as="h3">{t("isThisYourVehicle")}</Header>
        <Image src={vehicle.dashboard_url || placeholderCarImg} />
        <Label>
          {vehicle.year} {vehicle.make} {vehicle.model}
        </Label>
      </div>
      <div className="action-button">
        <Button
          fluid
          onClick={handleVehicleSubmit}
          loading={isSubmitting}
          disabled={isSubmitting}
          className="primary-button"
        >
          {t("myVehicle")}
        </Button>

        <Button
          fluid
          basic
          color="black"
          onClick={handleToggleVehicleInfo}
          loading={isSubmitting}
          disabled={isSubmitting}
          className="secondary-button"
        >
          {t("notMyVehicle")}
        </Button>
      </div>
    </Card>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let vehicle = state.selectedVehicle.selectedVehicle || {}
  let cart
  let currentActiveOrder =
    user.active_orders && user.active_orders.find((o) => o.vehicle_id == user.activeVehicleId)

  if (currentActiveOrder) {
    cart = currentActiveOrder
  } else {
    if (props.cartId) {
      cart = user.active_carts && user.active_carts.filter((c) => c.id == Number(props.cartId))[0]
    } else {
      cart =
        user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
    }
  }

  if (!cart || !cart.order_services) {
    cart = { estimated_total: 0, order_services: [] }
  }

  return {
    user: user,
    cart: cart,
    user: user,
    vehicle
  }
}

export default withRouter(connect(mapStateToProps)(withTranslation("vehicleDetails")(VehicleInfo)))
